import AppHeader from "../../layout/AppHeader";
import LoadObjects from '../../xpost/views/services/load.objects/LoadObjects.vue';
import LoadObjectsAdd from '../../xpost/views/services/load.objects/LoadObjectsAdd.vue';
import LoadObjectsCheck from '../../xpost/views/services/load.objects/LoadObjectsCheck.vue';

const LoadObjectsRoutes = [
  {
    path: "/servicos/cargaobjetos",
    name: "load.objects",
    components: {
      header: AppHeader,
      default: LoadObjects,
    }
  },
  {
    path: "/servicos/cargaobjetos/adicionar",
    name: "load.objects.add",
    components: {
      header: AppHeader,
      default: LoadObjectsAdd,
    }
  },
  {
    path: "/servicos/cargaobjetos/adicionar/:id",
    name: "load.objects.edit",
    components: {
      header: AppHeader,
      default: LoadObjectsAdd,
    }
  },
  {
    path: "/servicos/cargaobjetos/conferir",
    name: "load.objects.check",
    components: {
      header: AppHeader,
      default: LoadObjectsCheck,
    }
  },
]

export default LoadObjectsRoutes;